// filters out keys starting with "_"
export const postValues = values => Object.keys(values).reduce((newObj, key) =>
  key[0] === '_' ? newObj : { ...newObj, [key]: values[key] }, {})
